export const ADD_EMPLOYEES_TABLE_TEST_IDS = {
  TABLE: 'add-employees-table-test-id',
  TABLE_ROW: 'add-employees-table-row-test-id',
} as const;

export const TABLE_MANAGEMENT_PANEL_TEST_IDS = {
  COLLECTION_MANAGEMENT_HEADER: 'collection-management-header-test-id',
  ADD_EMPLOYEES_DROPDOWN: 'add-employees-dropdown-test-id',
  EMPLOYEES_STATUS_FILTER_DROPDOWN: 'employees-status-filter-dropdown-test-id',
  ADD_ON_FILTER_DROPDOWN: 'add-on-filter-dropdown-test-id',
} as const;

export const ADD_ON_METHOD_FILTER_DROPDOWN_TEST_IDS = {
  DROPDOWN_OPTIONS: 'add-on-method-filter-dropdown-test-id',
};

export const EMPLOYEE_ADDED_METHOD_TAG_TEST_IDS = {
  ADD_CIRCLE: 'add-circle-test-id',
  INFO_BUTTON_FILLED: 'info-button-filled-test-id',
  ACCOUNT_CIRCLE: 'account-circle-test-id',
};
